import { NODE_CONTEXT_IMPORT } from "./NodeContextImportConstants";

function num(v, fallback = 0) {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
}

function lines() {
  return NODE_CONTEXT_IMPORT.statusLines;
}

export function buildImportStatusDisplay({
  totalNodes,
  createdNodes,
  updatedNodes,
  failedNodes,
  importStatus,
}) {
  const L = lines();
  return [
    `${L.totalNodes} ${totalNodes}`,
    `${L.createdNodes} ${createdNodes}`,
    `${L.updatedNodes} ${updatedNodes}`,
    `${L.failedNodes} ${failedNodes}`,
    `${L.importStatus} ${importStatus}`,
  ].join("\n");
}

export function formatValidateApiResponseToStatus(data) {
  const L = lines();
  if (!data || typeof data !== "object") {
    return {
      display: buildImportStatusDisplay({
        totalNodes: 0,
        createdNodes: 0,
        updatedNodes: 0,
        failedNodes: 0,
        importStatus: L.validationFailed,
      }),
      isValid: false,
      tier: "error",
    };
  }
  const isValid = Boolean(data.is_valid);
  const total = num(data.total_nodes);
  const created = num(data.created_nodes);
  const updated = num(data.updated_nodes);
  const failed = num(data.failed_nodes);
  const importStatus = isValid ? L.validationSuccessful : L.validationFailed;
  return {
    display: buildImportStatusDisplay({
      totalNodes: total,
      createdNodes: created,
      updatedNodes: updated,
      failedNodes: failed,
      importStatus,
    }),
    isValid,
    tier: isValid ? "success" : "error",
  };
}

export function formatSyncApiResponseToStatus(data) {
  const L = lines();
  if (!data || typeof data !== "object") {
    return {
      display: buildImportStatusDisplay({
        totalNodes: 0,
        createdNodes: 0,
        updatedNodes: 0,
        failedNodes: 0,
        importStatus: L.importFailed,
      }),
      success: false,
      tier: "error",
    };
  }
  const created = num(data.nodes_created);
  const updated = num(data.nodes_updated);
  const skipped = num(data.nodes_skipped);
  const totalFromApi = num(data.total_nodes);
  const total =
    totalFromApi > 0 ? totalFromApi : created + updated + skipped;
  const failed = num(data.failed_nodes ?? (data.error ? 1 : 0));
  const statusUpper = String(data.status ?? "").toUpperCase();
  const success = statusUpper === "COMPLETED" && !data.error;
  const importStatus = success ? L.importSuccessful : L.importFailed;
  return {
    display: buildImportStatusDisplay({
      totalNodes: total,
      createdNodes: created,
      updatedNodes: updated,
      failedNodes: failed,
      importStatus,
    }),
    success,
    tier: success ? "success" : "error",
  };
}
